export function tourTarget(id: string): { 'data-tour': string } {
  return { 'data-tour': id };
}

export function resolveTourTarget(
  target: string | { mobile: string; desktop: string },
  isMobile: boolean,
): string {
  if (typeof target === 'string') {
    return target;
  }
  return isMobile ? target.mobile : target.desktop;
}

export function matchesExpectedRoute(
  pathname: string,
  expectedRoute: string,
): boolean {
  if (expectedRoute === '/eventos') {
    return (
      pathname === '/eventos' ||
      pathname === '/' ||
      pathname.startsWith('/evento/')
    );
  }
  return pathname === expectedRoute || pathname.startsWith(`${expectedRoute}/`);
}
